<div class="questions-contaiener" mat-dialog-content>
    Hold on for just a few more seconds while we finish generating everything for you!✨😏
</div>

<div mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Close</button>
</div>
